export const useNormalizeText = () => {
  const normalizeText = (text: string) =>
    text
    .toLowerCase()
    .replace(/[ąćęłńóśźż]/g, char => ({
      ą: 'a',
      ć: 'c',
      ę: 'e',
      ł: 'l',
      ń: 'n',
      ó: 'o',
      ś: 's',
      ź: 'z',
      ż: 'z',
    })[char] || char)

  return {
    normalizeText,
  }
}
